import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/safety-guidelines-hero.svg";
import arrowIcon from "@assets/images/Frame-9.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import { HeroBadge, useFeedbackModal } from "@components/ui";
import { HeroSection, EmergencyCTASection } from "../../components";
import { SafetyGuidelinesPage } from "@features/general";

export function SafetyGuidelines() {
  const { openModal } = useFeedbackModal();

  return (
    <SafetyGuidelinesPage
      hero={
        <HeroSection
          title="Your Safety Comes First, Every Second Counts"
          description="Gas safety is a shared responsibility. GASIS ensures certified installations, strict inspections, and 24/7 emergency support and you can protect your home or business by following the essential guidelines below."
          heroImage={heroImage}
          cta={
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <button className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-2 bg-[#090d2c] rounded-[40px] hover:bg-[#3d405e] transition-colors">
                <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white whitespace-nowrap">
                  Call 800-GASIS (42747)
                </span>
                <img src={arrowIcon} alt="" className="w-8 md:w-10 rounded-full" />
              </button>
              <button className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-2 bg-[#090d2c] rounded-[40px] hover:bg-[#3d405e] transition-colors">
                <span className="text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-white whitespace-nowrap">
                  View Safety Guidelines
                </span>
                <img src={arrowIcon} alt="" className="w-8 md:w-10 rounded-full" />
              </button>
            </div>
          }
          badge={
            <HeroBadge
              text="Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business."
              linkText="Report an Emergency Online"
              onLinkClick={() => openModal("Emergency / Maintenance")}
            />
          }
        />
      }
      footer={
        <>
          <EmergencyCTASection
            title="Let's Build a Safer Energy Future Together"
            subtitle="End-to-end gas network planning for new developments"
          >
            <div className="rounded-[12px] md:rounded-3xl bg-white flex flex-col items-start p-4 md:p-6 gap-2.5">
              <div className="flex items-end">
                <div className="flex items-start gap-2">
                  <div className="flex flex-col items-start justify-center gap-3.5">
                    <img src={mailIcon} alt="" className="w-4 h-4" />
                    <img src={phoneIcon} alt="" className="w-4 h-4" />
                  </div>
                  <p className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-[32px] font-medium text-[#20262b]">
                    help@gasis.ae
                    <br />
                    Support (8 AM - 8 PM)
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <img src={buildingIcon} alt="" className="w-5 h-5" />
                <p className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-[32px] font-medium text-[#20262b]">
                  Sunday - Thursday (8 AM - 6 PM)
                </p>
              </div>
            </div>
          </EmergencyCTASection>
          <Footer />
        </>
      }
    />
  );
}

export default SafetyGuidelines;
